import { inject, Injectable } from '@angular/core';
import { BaseApiService } from '../base-api.service';
interface GetDetailRequest {
  [key: string]: string;
  catid: string;
}
export interface FileData {
  path: string;
}
export interface GetDetailResponse {
  catName: string;
  catId: number;
  catContent: string;
  fileList: FileData[];
}
@Injectable({
  providedIn: 'root',
})
export class GetDetailService {
  private baseApiService = inject(BaseApiService);

  getDetailApi(url: string, req: GetDetailRequest) {
    return this.baseApiService.basePost<GetDetailRequest, GetDetailResponse>(
      url,
      req
    );
  }
}
